
define('text!presentation/error/views/error.html',[],function () { return '<div class="form-container">\n    <h1>404 - Page Not Found</h1>\n    <h4>We\'re sorry but the link you were trying to go to doesn\'t exist.</h4>\n</div>';});

